import styled from 'styled-components';

const PostContainer = styled.div`
  .empty-post {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    h3 {
      font-weight: 600;
      color: ${({ theme }) => theme.colors[2]};
    }
    h4 {
      color: grey;
    }
    .profile-create-post {
      margin-top: 20px;
      font-weight: 600;
    }
  }
`;

export { PostContainer };
